import { getPatientCanSendMessage } from './getPatientCanSendMessage.js';
import { getPatientChatState } from './getPatientChatState.js';
import { getPendingAgentMessage } from './getPendingAgentMessage.js';
/**
 * Whether the patient chat composer should be shown.
 *
 * The patient status is the authoritative gate: the input shows only on the patient's turn
 * (`ACTIVE`). `BUSY` (the agent is working — and there is no way to interrupt it), `HIDDEN`, and
 * `ENDED` all hide it unconditionally. This is what makes `AGENT_BUSY` blocking: `getPendingAgentMessage`
 * deliberately skips the technical `AGENT_BUSY`, so without the status gate a pending question or a
 * holding message would leak the composer through while the agent generates the next turn.
 *
 * Within an `ACTIVE` turn, `getPendingAgentMessage` only refines *which* input surface to show: a
 * pending free-text question → answer mode; a plain agent message → free reply; a structured question
 * keeps its inline widget, so the composer stays hidden. Otherwise the patient may send a free message.
 *
 * @__NO_SIDE_EFFECTS__
 */
export function getPatientCanShowChatInput(events) {
    if (getPatientChatState(events).status !== 'ACTIVE') {
        return false;
    }
    const pending = getPendingAgentMessage(events, { target: 'PATIENT', includeMessages: true });
    if (pending?.type === 'AGENT_QUESTION') {
        return pending.input.type === 'TEXT';
    }
    if (pending?.type === 'AGENT_MESSAGE') {
        return true;
    }
    return getPatientCanSendMessage(events);
}
//# sourceMappingURL=getPatientCanShowChatInput.js.map